import { render, staticRenderFns } from "./SubpageSettings.vue?vue&type=template&id=57cbc9af&scoped=true&"
import script from "./SubpageSettings.vue?vue&type=script&lang=js&"
export * from "./SubpageSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57cbc9af",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/bamboo-agent-home/xml-data/build-dir/WWW-WWW-JOB1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57cbc9af')) {
      api.createRecord('57cbc9af', component.options)
    } else {
      api.reload('57cbc9af', component.options)
    }
    module.hot.accept("./SubpageSettings.vue?vue&type=template&id=57cbc9af&scoped=true&", function () {
      api.rerender('57cbc9af', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/src/components/userprofile/SubpageSettings.vue"
export default component.exports